import { render, staticRenderFns } from "./BelongsModify.vue?vue&type=template&id=ab5f6fa2&scoped=true&"
import script from "./BelongsModify.vue?vue&type=script&lang=js&"
export * from "./BelongsModify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5f6fa2",
  null
  
)

export default component.exports